import { Attribute } from "../types/attribute";
import { get } from "./fetch.core";

async function listAttributes() {
  const res = await get<Attribute[]>("/admin/attribute/list");
  return res.data;
}

async function getAttribute(id: string) {
  const res = await get<Attribute>(`/admin/attribute/get?id=${id}`);
  return res.data;
}

const obj = {
  listAttributes,
  getAttribute,
};

export default obj;
